export default __webpack_public_path__ + "status-new-md.743798f2.svg";